<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.settings" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>Veranstaltungen</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="event">
  <div class="white-wrapper">
    <div class="event__header">
      <span class="event__title" [innerHTML]="(content$ | async)?.title"></span>
      <ion-icon class="event__ellipsis" slot="icon-only" name="ellipsis-vertical" (click)="presentGeneralPopover($event)"></ion-icon>
    </div>

    <div class="event__grid">
      <div class="event__grid__item --description">
        <span class="event__grid__item__label" [innerHTML]="'Beschreibung'"></span>
        <span class="event__grid__item__value" [innerHTML]="(content$ | async)?.description | linebreaks"></span>
      </div>
      <div class="event__grid__item --image">
        <img [src]="(content$ | async)?.imageUrl || 'assets/icon/apple-touch-icon.png'" alt="" />
      </div>
      <div class="event__grid__item__content">
        <div class="event__grid__item">
          <span class="event__grid__item__label" [innerHTML]="'Priorität'"></span>
          <span class="event__grid__item__value" [innerHTML]="'EVENT_PRIORITY.' + (content$ | async)?.priority | translate"></span>
        </div>
        <div class="event__grid__item">
          <span class="event__grid__item__label" [innerHTML]="'Typ'"></span>
          <span class="event__grid__item__value" [innerHTML]="'EVENT_TYPE.' + (content$ | async)?.type | translate"></span>
        </div>
        <div class="event__grid__item">
          <span class="event__grid__item__label" [innerHTML]="'Dauer'"></span>
          <span class="event__grid__item__value" [innerHTML]="(content$ | async)?.duration + ' minuten'"></span>
        </div>
        <div class="event__grid__item">
          <span class="event__grid__item__label" [innerHTML]="'Price'"></span>
          <span class="event__grid__item__value" [innerHTML]="(content$ | async)?.price | currency:'EUR':'symbol'"></span>
        </div>
        <div class="event__grid__item">
          <span class="event__grid__item__label" [innerHTML]="'Sichtbarkeit'"></span>
          <img class="event__grid__item__value --public" src="assets/event/private-{{(content$ | async)?.isPrivate}}.png" />
        </div>
      </div>
    </div>

    <div class="events">
      <span class="event__grid__item__label" [innerHTML]="'Geplante Termine'"></span>
      <span
        *ngIf="!(events$ | async)?.length && !(loading$ | async)"
        class="event__grid__item__value --is-empty"
        [innerHTML]="'Noch keine Ereignisse zu diesem Inhalt'"
      ></span>

      <ion-list class="events__list">
        <ion-item *ngFor="let event of events$ | async; trackBy: trackBy" class="events__list__item" detail="false">
          <div class="events__list__item__wrapper">
            <div class="events__list__item__detail">
              <span class="events__list__item__detail__date" [innerHTML]="event.date | date:'dd. MMMM YYYY HH:mm'"></span>
              <span class="events__list__item__detail__referent" [innerHTML]="(event.referentId|toReferent|async)?.name"></span>
              <span class="events__list__item__detail__location" [innerHTML]="event.location"></span>
            </div>
            <div class="events__list__item__action">
              <ion-icon
                class="events__list__item__action__ellipsis"
                slot="icon-only"
                name="ellipsis-vertical"
                (click)="presentEventPopover($event, event)"
              ></ion-icon>
            </div>
          </div>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
